import { render, staticRenderFns } from "./CreateVirement.vue?vue&type=template&id=2c582b63"
import script from "./CreateVirement.vue?vue&type=script&lang=js"
export * from "./CreateVirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports